import { useEffect } from 'react';

/*
 * The page has several looping background videos that previously all played
 * at once, even when scrolled far off screen. On tablets that costs smooth
 * scrolling and battery. This plays each autoplay video only while it's
 * near the screen.
 */
const usePauseOffscreenVideos = () => {
  useEffect(() => {
    if (!('IntersectionObserver' in window)) return undefined;
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(({ target, isIntersecting }) => {
          if (isIntersecting) {
            const p = target.play();
            if (p && p.catch) p.catch(() => {}); // autoplay may be refused (e.g. Low Power Mode)
          } else {
            target.pause();
          }
        });
      },
      { rootMargin: '200px 0px' }
    );
    document.querySelectorAll('video[autoplay]').forEach((v) => observer.observe(v));
    return () => observer.disconnect();
  }, []);
};

export default usePauseOffscreenVideos;
